
import "../../assets/sass/components/dashboard/_dashboardItem.scss"
import {useDispatch, useSelector} from "react-redux";
import React, {forwardRef, useContext, useEffect, useRef, useState} from 'react';
import { Redirect } from "react-router-dom";
import "react-step-progress-bar/styles.css";

import routes from "../../constants/Routes";
import AppContext from "../../contexts/AppContext";
import {getAssessmentCompletion, isEmptyObject, isNSCSubdomain, makeSerializable} from "../../utils/Utils";
import CONSTANT from "../../constants/Constant";
import DashboardItem from "./DashboardItem";
import {_getInCompleteAssessmentType, getResumeGroupFromId} from "./dashboardUtills"
import NotificationInfo from "./notification/NotificationInfo";
import ConfirmationDialog from "../shared/Popups/ConfirmationDialog";
import BiometricMovementAndCautionQuestionContainer from "../shared/MovementModal/BiometricMovementAndCautionQuestionContainer";
import ResumeBtn from "./notification/ResumeBtn";
import MyAssessmentsDetail from "../my-assessments/MyAssessmentsDetail";
import MobileAppsLink from "../mobile-apps/AllAppsLink";
import AlertModal from "../shared/AlertModal";
import StepBar from "../shared/stepbar/StepBar";
import useDashboardBody from "./useDashboardBody";
import {
    resetDashboardState,
    setFollowUpAssessments, setInvitationListDoNotHaveTestIds, setIsShowIsFollowUpPopup, setLastIncompletedAssessments,
    setOpenBiometricMovementAndCautionQuestionContainer, setShowDetailInstruction
} from "../../features/dashboard/dashboardSlice";
import useHandleExpiredAndUpcomingMeetingPopupMsg from "../../hooks/useHandleExpiredAndUpcomingMeetingPopupMsg";
import PurchasedPackage from "./PurchasedPackage";
import usePurchasedPackage from "./usePurchasedPackage";
import GLOBAL from "../../global";
import RemoteAssistanceSection from "../remote-assistance/RemoteAssistanceSection";

const DashboardBody = forwardRef((props, ref) => {
    const { allNotifications, isLoadingNotification } = props;
    const { authenticated,userInfo } = useContext(AppContext);
    const dispatch = useDispatch();
    const { IsSpinealignEnabled } = userInfo.Permissions;

    const { handleNewUser, handleRemoteAssistance, notificationHandler, handleClickMore } = useDashboardBody(
        props?.fetchNotificationData);
    const { getAssessmentAvailabilityStatus } = useHandleExpiredAndUpcomingMeetingPopupMsg();
    const { handlePurchasePackageForNewUser } = usePurchasedPackage();

    const dashboardRootState = useSelector(state => state.dashboard);
    const purchasePackageState = useSelector(state => state.purchasePackage);

    const lastIncompletedAssessments = dashboardRootState?.lastIncompletedAssessments || [];
    const showLoadingAtJoinNowBtn = dashboardRootState?.showLoadingAtJoinNowBtn || false;
    const isShowIsFollowUpPopup = dashboardRootState?.isShowIsFollowUpPopup || false;
    const showDetailInstruction = dashboardRootState?.showDetailInstruction || false;
    const showLoadingInConformTelemedicine = dashboardRootState?.showLoadingInConformTelemedicine || false;
    const followUpAssessments = dashboardRootState?.followUpAssessments || [];
    const invitationListDoNotHaveTestIds = dashboardRootState?.invitationListDoNotHaveTestIds || [];
    const selectedTelemedicineInvitationId = dashboardRootState?.selectedTelemedicineInvitationId || '';

    const biometric = dashboardRootState?.biometric || {};
    const openBiometricMovementAndCautionQuestionContainer = biometric?.openBiometricMovementAndCautionQuestionContainer || false;
    const selectedBodyRegionsAndTestId = {
        testId: biometric?.testId || '',
        selectedBodyRegions: biometric?.selectedBodyRegions || []
    }

    const purchasePackageIsLoading = purchasePackageState?.isLoading || false;
    const packages = purchasePackageState?.packages || [];

    const conformationAlertContentRef = useRef({});
    const isCalledInitializedRef = useRef(false);
    // const subscriptionType = GLOBAL.USER_INFO.SUBSCRIPTION_TYPE;
    const subscriptionType = parseInt(localStorage.getItem('SubscriptionType'), 10);


    useEffect(() => {
        let tempLastIncompletedAssessments = [];
        let followUpAssessments = [];
        let tempInvitationListDoNotHaveTestId = [];
        if(allNotifications && allNotifications.length > 0) {
            tempLastIncompletedAssessments = allNotifications.filter(notification => {
                let assessmentAvailabilityStatus = getAssessmentAvailabilityStatus(notification?.MeetingStart, notification?.MeetingEnd);
                return notification.IsLastIncomplete
                    &&
                    !notification.IsFollowup &&
                    (
                        notification.InvitationTypeId !== CONSTANT.INVITATION_TYPE.Telemedicine ||
                        (notification.InvitationTypeId === CONSTANT.INVITATION_TYPE.Telemedicine && assessmentAvailabilityStatus !== CONSTANT.ASSESSMENT_AVAILABILITY.EXPIRED.KEY)
                    ) &&
                    (
                        notification.InvitationTypeId !== CONSTANT.INVITATION_TYPE.InClinic ||
                        (notification.InvitationTypeId === CONSTANT.INVITATION_TYPE.InClinic && assessmentAvailabilityStatus !== CONSTANT.ASSESSMENT_AVAILABILITY.EXPIRED.KEY)
                    )
            });

            tempInvitationListDoNotHaveTestId = allNotifications.filter(notification => !notification.TestId);
            followUpAssessments = allNotifications.filter(notification => {
                let assessmentAvailabilityStatus = getAssessmentAvailabilityStatus(notification?.MeetingStart, notification?.MeetingEnd);
                return notification.IsFollowup &&
                    (
                        notification.InvitationTypeId !== CONSTANT.INVITATION_TYPE.Telemedicine ||
                        (notification.InvitationTypeId === CONSTANT.INVITATION_TYPE.Telemedicine && assessmentAvailabilityStatus !== CONSTANT.ASSESSMENT_AVAILABILITY.EXPIRED.KEY)
                    ) &&
                    (
                        notification.InvitationTypeId !== CONSTANT.INVITATION_TYPE.InClinic ||
                        (notification.InvitationTypeId === CONSTANT.INVITATION_TYPE.InClinic && assessmentAvailabilityStatus !== CONSTANT.ASSESSMENT_AVAILABILITY.EXPIRED.KEY)
                    )
            });

            dispatch(setLastIncompletedAssessments(makeSerializable(tempLastIncompletedAssessments)));
            dispatch(setInvitationListDoNotHaveTestIds(makeSerializable(tempInvitationListDoNotHaveTestId)));
            dispatch(setFollowUpAssessments(makeSerializable(followUpAssessments)));
        }
        if(!isNSCSubdomain()) handleNewUser(allNotifications);
        handleRemoteAssistance();

    }, [allNotifications]);

    useEffect(() => {
        if(!purchasePackageIsLoading && packages.length > 0 && !isCalledInitializedRef.current) {
            isCalledInitializedRef.current = true;
            handlePurchasePackageForNewUser(packages, props?.fetchNotificationData);
        }
    }, [packages]);

    useEffect(() => {
        return () => {
            dispatch(resetDashboardState())
        }
    }, []);


    if (!authenticated) {
        return <Redirect to={`${routes.landing}`}/>;
    }

    const stepBar = (assessment = {}) => {
        const tempAssessment = isEmptyObject(assessment) ? lastIncompletedAssessments : assessment;

        return (
            <div className="padding-bottom-1-rem">
                <div className="margin-bottom-1-rem"></div>
                <StepBar groups={getAssessmentCompletion(tempAssessment?.AssessmentStatus)}
                     isShowName={true}
                     isShowFullName={false}
                />
            </div>
        )
    }

    const handleSetOpenBiometricMovementAndCautionQuestionContainer = () => {
        // as from BiometricMovementAndCautionQuestionContainer component we only close the biometric modal
        dispatch(setOpenBiometricMovementAndCautionQuestionContainer({
            openBiometricMovementAndCautionQuestionContainer: false,
            testId: '',
            selectedBodyRegions: []
        }));
    }

    return (
        <>
            {/*{(!isLoadingNotification || !purchasePackageIsLoading) && (*/}
                <>

                    {
                        !isNSCSubdomain() && <PurchasedPackage
                            callbackFetchNotificationData={props?.fetchNotificationData}
                        />
                    }

                    {(invitationListDoNotHaveTestIds.length > 0) ? (
                            <DashboardItem title={`New Assessment Invitation`} largeTitle="NEW ASSESSMENT INVITATION" overflow={true} showOnlyOneImage={false}>
                                <div>
                                    {invitationListDoNotHaveTestIds.map((item, index) => (
                                        <div className="dashboard-item" key={index}>
                                            <div className="d-flex-center-center flex-wrap">
                                                <div className="">
                                                    <NotificationInfo
                                                        notificationData={{
                                                            MeetingDate: item?.MeetingDate,
                                                            BodyRegionList: item?.BodyRegionList,
                                                            InvitationTypeName: item?.InvitationTypeName,
                                                            InvitationTypeId: item?.InvitationTypeId,
                                                            SportsType: item?.SportsType,
                                                        }}
                                                    >
                                                        <ResumeBtn
                                                            InvitationTypeId={item?.InvitationTypeId}
                                                            firstIncompleteGroupName={getResumeGroupFromId(item?.ResumeGroupId)}
                                                            isLoading={!showLoadingAtJoinNowBtn && selectedTelemedicineInvitationId === item.InvitationId}
                                                            notificationHandler={notificationHandler}
                                                            conformationAlertContentRef={conformationAlertContentRef}
                                                            notificationData={item}
                                                            IsLastIncomplete={item?.IsLastIncomplete}
                                                            MeetingStart={item?.MeetingStart}
                                                            MeetingEnd={item?.MeetingEnd}
                                                        />
                                                    </NotificationInfo>
                                                </div>
                                            </div>
                                            <div className="dashboard-item-spepbar-container" style={{height: "1rem"}}></div>
                                        </div>
                                    ))}
                                </div>
                            </DashboardItem>
                        )
                        :
                        null
                    }

                    {/*{lastIncompletedAssessments.length > 0 ? (*/}
                    {/*    <DashboardItem title="Last Incompleted Assessment" largeTitle="INCOMPLETE ASSESSMENT"*/}
                    {/*                   showOnlyOneImage={false}>*/}
                    {/*        {lastIncompletedAssessments.slice(0,2).map((item, index) => (*/}
                    {/*            <div className="dashboard-item" key={index}>*/}
                    {/*                <div className="">*/}
                    {/*                    <div*/}
                    {/*                        className="d-flex justify-content-between align-content-center flex-wrap dashboard-item-wrapper">*/}
                    {/*                        <div className="notification wrapper">*/}
                    {/*                            <NotificationInfo*/}
                    {/*                                notificationData={{*/}
                    {/*                                    MeetingDate: item?.MeetingDate,*/}
                    {/*                                    TestId: item?.TestId,*/}
                    {/*                                    BodyRegionList: item?.BodyRegionList,*/}
                    {/*                                    InvitationTypeName: item.InvitationTypeName,*/}
                    {/*                                    InvitationTypeId: item?.InvitationTypeId,*/}
                    {/*                                    SportsType: item?.SportsType,*/}
                    {/*                                }}*/}
                    {/*                            >*/}
                    {/*                                <ResumeBtn*/}
                    {/*                                    InvitationTypeId={item?.InvitationTypeId}*/}
                    {/*                                    firstIncompleteGroupName={_getInCompleteAssessmentType(item?.AssessmentStatus)}*/}
                    {/*                                    isLoading={showLoadingAtJoinNowBtn && selectedTelemedicineInvitationId === item.InvitationId}*/}
                    {/*                                    notificationHandler={notificationHandler}*/}
                    {/*                                    conformationAlertContentRef={conformationAlertContentRef}*/}
                    {/*                                    notificationData={{*/}
                    {/*                                        ...item*/}
                    {/*                                    }}*/}
                    {/*                                    IsLastIncomplete={item?.IsLastIncomplete}*/}
                    {/*                                    MeetingStart={item?.MeetingStart}*/}
                    {/*                                    MeetingEnd={item?.MeetingEnd}*/}
                    {/*                                />*/}
                    {/*                            </NotificationInfo>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}
                    {/*                </div>*/}
                    {/*                {stepBar(item)}*/}
                    {/*                <div className="dashboard-item-spepbar-container" style={{height: "1rem"}}></div>*/}
                    {/*            </div>*/}
                    {/*        ))}*/}
                    {/*        {lastIncompletedAssessments.length > 2 && (*/}
                    {/*            <div className="w-full pb-3 d-flex justify-content-center">*/}
                    {/*                <button*/}
                    {/*                    className="button button-dashboard"*/}
                    {/*                    onClick={() => handleClickMore(CONSTANT.ASSESSMENT_TYPE.LAST_INCOMPLETE.key)}>*/}
                    {/*                    More*/}
                    {/*                </button>*/}
                    {/*            </div>*/}
                    {/*        )}*/}
                    {/*    </DashboardItem>*/}
                    {/*)*/}
                    {/*    :*/}
                    {/*    null*/}
                    {/*}*/}

                    {/*{followUpAssessments.length > 0 ? (*/}
                    {/*    <DashboardItem title="Follow Up Assessment" largeTitle="FOLLOW-UP ASSESSMENT" showOnlyOneImage={false}>*/}
                    {/*        {followUpAssessments.slice(0, 2).map((item, index) => (*/}
                    {/*            <div className="dashboard-item" key={index}>*/}
                    {/*                <div className="">*/}
                    {/*                    <div className="d-flex justify-content-between align-content-center flex-wrap dashboard-item-wrapper">*/}
                    {/*                        <div className="notification wrapper">*/}
                    {/*                            <NotificationInfo*/}
                    {/*                                notificationData={{*/}
                    {/*                                    MeetingDate: item?.MeetingDate,*/}
                    {/*                                    TestId: item?.TestId,*/}
                    {/*                                    BodyRegionList: item?.BodyRegionList,*/}
                    {/*                                    InvitationTypeName: item.InvitationTypeName,*/}
                    {/*                                    InvitationTypeId: item?.InvitationTypeId,*/}
                    {/*                                    SportsType: item?.SportsType,*/}

                    {/*                                }}*/}
                    {/*                            >*/}
                    {/*                                <ResumeBtn*/}
                    {/*                                    InvitationTypeId={item?.InvitationTypeId}*/}
                    {/*                                    firstIncompleteGroupName={_getInCompleteAssessmentType(item?.AssessmentStatus)}*/}
                    {/*                                    isLoading={showLoadingAtJoinNowBtn && selectedTelemedicineInvitationId === item.InvitationId}*/}
                    {/*                                    notificationHandler={notificationHandler}*/}
                    {/*                                    conformationAlertContentRef={conformationAlertContentRef}*/}
                    {/*                                    notificationData={{*/}
                    {/*                                        ...item*/}
                    {/*                                    }}*/}
                    {/*                                    IsLastIncomplete={item?.IsLastIncomplete}*/}
                    {/*                                    MeetingStart={item?.MeetingStart}*/}
                    {/*                                    MeetingEnd={item?.MeetingEnd}*/}
                    {/*                                />*/}
                    {/*                            </NotificationInfo>*/}
                    {/*                        </div>*/}
                    {/*                    </div>*/}
                    {/*                </div>*/}
                    {/*                {stepBar(item)}*/}
                    {/*                <div className="dashboard-item-spepbar-container" style={{height: "1rem"}}></div>*/}
                    {/*            </div>*/}
                    {/*        ))}*/}
                    {/*        {followUpAssessments.length > 2 && (*/}
                    {/*            <div className="w-full pb-3 d-flex justify-content-center">*/}
                    {/*                <button*/}
                    {/*                    className="button button-dashboard"*/}
                    {/*                    onClick={() => handleClickMore(CONSTANT.ASSESSMENT_TYPE.FOLLOW_UP.key)}>*/}
                    {/*                    More*/}
                    {/*                </button>*/}
                    {/*            </div>*/}
                    {/*        )}*/}
                    {/*    </DashboardItem>*/}
                    {/*)*/}
                    {/*    :*/}
                    {/*    null*/}
                    {/*}*/}


                    <RemoteAssistanceSection />
                    <h2 className="w-100-percent my-assessment-heading">My Assessments</h2>
                    <MyAssessmentsDetail showCompletedAssessments={false} disableBiometricModal={true} isDashboard={true} />
                    {/*{*/}
                    {/*    (IsSpinealignEnabled && subscriptionType === 1) && <MobileAppsLink/>*/}
                    {/*}*/}

                </>
            {/*)}*/}
            <ConfirmationDialog
                headerText={conformationAlertContentRef.current.headerText}
                show={isShowIsFollowUpPopup}
                cancelText={conformationAlertContentRef.current.noBtnText}
                confirmText={conformationAlertContentRef.current.yesBtnText}
                shouldConfirmBtnDisabled={conformationAlertContentRef.current?.shouldConfirmBtnDisabled || false}
                showLoadingInConform={showLoadingInConformTelemedicine}
                onConfirm={conformationAlertContentRef.current.onClickYes}
                toggleDialog={conformationAlertContentRef.current.onClickNo}
                onClickHeaderClose={() => {
                    dispatch(setIsShowIsFollowUpPopup(false));
                    conformationAlertContentRef.current = {};
                }}
                showYesBtn={conformationAlertContentRef.current?.showYesBtn !== undefined ? conformationAlertContentRef.current?.showYesBtn : true }
            >
                {conformationAlertContentRef.current.content}
            </ConfirmationDialog>

            <AlertModal
                show={showDetailInstruction}
                type="info"
                title=""
                confirmBtnText="Ok"
                showConfirm={true}
                showCancel={false}
                onConfirm={() => dispatch(setShowDetailInstruction(false))}
                closeOnClickOutside={false}>
                <div className='tele_sweetalert_message'>
                    If there have been any notable changes to your weight, daily activities, or your acute or chronic chief complaints,
                    please update these entries by clicking "Update My Background"
                </div>
            </AlertModal>

            {openBiometricMovementAndCautionQuestionContainer &&
                <BiometricMovementAndCautionQuestionContainer
                    data={{
                        testId: selectedBodyRegionsAndTestId?.testId,
                        selectedBodyRegions: {bodyRegionList : selectedBodyRegionsAndTestId?.selectedBodyRegions },
                        openBiometricMovementAndCautionQuestionContainer,
                    }}
                    setOpenBiometricMovementAndCautionQuestionContainer={handleSetOpenBiometricMovementAndCautionQuestionContainer}
                />
            }
        </>
    )
});

export default DashboardBody;
